import { Administrator, AdministratorRequest } from './organization.models';

// eslint-disable-next-line @typescript-eslint/no-namespace
export namespace OrganizationActions {
  export class LoadAll {
    static readonly type = '[ORGANIZATION] Load All';
  }

  export class View {
    static readonly type = '[ORGANIZATION] View';
    constructor(public organizationId: string) {}
  }

  export class Register {
    static readonly type = '[ORGANIZATION] Register';
    constructor(
      public form: {
        name: string;
        parent: { id: string };
        isSupervisor: boolean;
        contactName: string;
        contactPhone: string;
        contactEmail: string;
      }
    ) {}
  }

  export class ClearCurrent {
    static readonly type = '[ORGANIZATION] Clear Current';
  }

  export class UpdateOrganizationSettings {
    static readonly type = '[ORGANIZATION] Update Organization Settings';
    constructor(
      public organizationNumber: string,
      public coAddress: string,
      public streetAddress: string,
      public zipCode: string,
      public city: string,
      public swishRecipients: { number: string; name: string; default: boolean; enabled: boolean }[],
      // public swishNumber: string,
      public swishPrefix: string,
      public defaultPartialPaymentAllowed: boolean,
      public defaultSmsPaymentReminderEnabled: boolean
    ) {}
  }

  export class HandleAdministratorRequest {
    static readonly type = '[ORGANIZATION] Handle Administrator Request';
    constructor(
      public user: AdministratorRequest,
      public approve: boolean
    ) {}
  }

  export class UpdateDemoMode {
    static readonly type = '[ORGANIZATION] Update Demo Mode';
    constructor(public demoMode: boolean) {}
  }

  export class DeleteAdministrator {
    static readonly type = '[ORGANIZATION] Delete Administrator';
    constructor(public administrator: Administrator) {}
  }

  export class UploadLogo {
    static readonly type = '[ORGANIZATION] Upload Logo';
    constructor(public file: File) {}
  }

  export class SearchOrganization {
    static readonly type = '[ORGANIZATION] Search';
    constructor(public term: string) {}
  }

  export class ClearSearchResults {
    static readonly type = '[ORGANIZATION] Clear Search Results';
  }

  export class ClearImportSuggestion {
    static readonly type = '[ORGANIZATION] Clear Import Suggestion';
    constructor(public save = false) {}
  }

  export class RequestAdministratorPrivileges {
    static readonly type = '[ORGANIZATION] Request Administrator Privileges';
    constructor(
      public organizationId: string,
      public organizationName: string
    ) {}
  }

  export class RetireOrganization {
    static readonly type = '[ORGANIZATION] Retire';
  }

  export class LoadRetiredFiles {
    static readonly type = '[ORGANIZATION] Load Retired Files';
  }

  export class DownloadRetiredFiles {
    static readonly type = '[ORGANIZATION] Download Retired Files';
  }
}
